import { Path, PathBase } from "@constellation-academy/epic-ui";

export class AccountEditBaseDataPath extends PathBase {
	static readonly pathKey = "basedata";
}

export class AccountEditPath extends Path<typeof AccountEditPath> {
	static readonly pathKey = "edit";
	static readonly childPaths = [AccountEditBaseDataPath];
}
